module.exports = __webpack_public_path__ + "static/media/009-ufo.071e1dc6.svg";